import {colorSwatch} from '../utils/colorSwatch.js';
import React, {useMemo} from 'react';
import {parseColor, resizeLabelToFit} from '../utils/utils.js';

import {Panel9Slice, Text} from '@wonderlandengine/react-ui/components';
import {Align, Justify} from '@wonderlandengine/react-ui';
import {
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {FlatOpaqueTextured} from '../../types/materials.js';

let bm: FlatOpaqueTextured | null;

export const WindowHeader = (props: {title: string}) => {
    const rotbMats = useRotBMaterialContext() as RotBMaterialContextValue;
    bm = useMemo(() => rotbMats.titleBackgroundMaterial!.clone() as FlatOpaqueTextured, []);
    bm.setColor(parseColor(colorSwatch.TitleBackground));

    return (
        <Panel9Slice
            height={60}
            material={bm}
            borderTextureSize={0.3}
            justifyContent={Justify.Center}
            alignContent={Align.Center}
            alignItems={Align.Center}
            border={10}
            borderColor="#000000"
            flexGrow={0}
        >
            <Text
                fontSize={resizeLabelToFit(props.title, 500, 36)}
                textAlign="center"
                color={colorSwatch.TitleText}
                text={props.title}
            ></Text>
        </Panel9Slice>
    );
};
